import { Component, OnInit } from '@angular/core';
import { UsersService } from '../Services/users.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  users_list:any;
  
  constructor(private users:UsersService) { 
    //get all users 
    this.getAll();
  }

  ngOnInit() {
  }

  //get all users 
  getAll(){
    this.users.getUsers().subscribe(
      next=>{
        console.log(next);
        this.users_list=next['users'];
      },
      error=>{console.log(error)}
    )
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/users/users.component.ts